// extracted by mini-css-extract-plugin
export default {"xsSize":"575.98px","smSize":"767.98px","mdSize":"991.98px","xlSize":"1199.98px","defaultFontFamily":"\"Exo 2\",Arial","rootClassName":"col-component"};